<!-- Header wrapper -->
<form [formGroup]="filterGroup" (keydown.enter)="$event.preventDefault()">
  <div class="cc-content-header-panel">
    <!--Title-->
    <h3>{{'_General_Localization_Text_' | translate }}</h3>
  </div>

  <div class="cc-content-wrapper">
    <!--Action Panel-->
    <div class="cc-action-panel row">

      <div class="cc-filters d-flex align-items-end">
        <div class="cc-filters-application">
          <label>{{'_General_Application_Text_' | translate }}</label>
          <ng-multiselect-dropdown 
            placeholder="{{'_General_Select_Text_' | translate }}"
            [settings]="dropdownSettings"
            [data]="applicationModules"
            formControlName="applications"
            (onDropDownClose)="onDropDownClose()"
            [ngClass]="'cc-multi-select float-multi'"
            (onSelect)="onApplicationChange()"
            (onDeSelect)="onApplicationChange()"
            [(ngModel)]="selectedApplications"
          >
        
          </ng-multiselect-dropdown>
        </div>
        <div class="col-md-3 cc-filters-language">
          <label>{{'_General_Language_Text_' | translate }}</label>
          <select (change)="onLanguageChange()" formControlName="languages" class="cc-select-dropdown form-control">
            <option *ngFor="let language of languages; trackBy: languageTrackBy" [ngValue]="language" >{{language.languageName | translate}}</option>
          </select>
        </div>
      </div>

      <div class="localization-search">
        <!--Search-->
        <div class="cc-search">
          <input formControlName="filterText" (keydown.enter)="onFilterTextEnterKeyPress()" class="form-control" placeholder="{{'_General_Search_Text_' | translate }}"/>
          <button [ngClass]="{'show-btn': showClearButton}" (click)="onClearSearchTextClicked()" class="cc-close-btn"><span class="fas fa-times"></span></button>
          <button (click)="onFilterTextSearchClicked()" class="cc-search-btn"><span class="fas fa-search"></span></button>
        </div>
      </div>
    </div>

    <!-- Localization Grid Wrapper -->
    <div class="localization-checklists-permission-clients-grid-wrapper-grid-wrapper">
      <!-- Grid  -->
      <kendo-grid [data]="data" [sortable]="{allowUnsort: false, mode: 'single'}" scrollable="scrollable" (sortChange)="sortChange($event)" [sort]="sort" [pageable]="true" [pageSize]="pageInfo.PageSize" [skip]="(pageInfo.Page - 1) * pageInfo.PageSize" (pageChange)="onPageChange($event)">
        <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
        <kendo-grid-column field="applicationModuleName" title="{{'_General_Application_Text_' | translate }}" [headerStyle] ="{'font-weight' : 'bold'}"></kendo-grid-column>
        <kendo-grid-column field="localizeKey" title="{{'_General_Key_Text_' | translate }}" [headerStyle] ="{'font-weight' : 'bold'}"></kendo-grid-column>
        <kendo-grid-column field="defaultValue" title="{{'_General_Default_English_Text_' | translate }}" [headerStyle] ="{'font-weight' : 'bold'}"></kendo-grid-column>
        <kendo-grid-column field="textValue" [title]="languageColumnTitle" [headerStyle] ="{'font-weight' : 'bold'}"></kendo-grid-column>
        <kendo-grid-command-column title="{{'_General_Button_Action_Text_' | translate }}" [width]="120" [headerStyle] ="{'font-weight' : 'bold','text-align' : 'center'}">
          <ng-template kendoGridCellTemplate let-item>
            <div class="cell-items-center">
              <button class="cc-icon-btn" title="{{'_General_Button_Edit_Text_' | translate }}" (click)="onEditClick(item)"><span class="fas fa-pen"></span></button>
            </div>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
    </div>
  </div>
</form>



